<template>
  <section class="primaryInfo">
    <a
      name="home"
      style="
        position: relative;
        top: -420px;
        display: block;
        height: 0;
        overflow: hidden;
      "
    ></a>
    <section class="information">
      <section class="innerBox">
        <div class="info">
          <img
            src="../assets/img/permisson-comparison1.jpg"
            alt="compare ToTok with other secure messaging apps such as WhatsApp, Telegram and Facebook Messenger"
            class="img_container-item"
          />
          <img
            src="../assets/img/permisson-comparison2.jpg"
            alt="compare ToTok with other secure messaging apps such as WhatsApp, Telegram and Facebook Messenger"
            class="img_container-item"
          />
          <img
            src="../assets/img/permisson-comparison3.jpg"
            alt="compare ToTok with other secure messaging apps such as WhatsApp, Telegram and Facebook Messenger"
            class="img_container-item"
          />
          <img
            src="../assets/img/permisson-comparison4.jpg"
            alt="compare ToTok with other secure messaging apps such as WhatsApp, Telegram and Facebook Messenger"
            class="img_container-item"
          />
          <img
            src="../assets/img/permisson-comparison5.jpg"
            alt="compare ToTok with other secure messaging apps such as WhatsApp, Telegram and Facebook Messenger"
            class="img_container-item"
          />
        </div>
        <!-- <div class="cp">All rights reserved, 2020 © Totok Pte. Ltd.</div> -->
      </section>
    </section>
    <Footer></Footer>
    <FootBanner></FootBanner>
  </section>
</template>

<script>
import NewsBar from "@/components/NewsBar.vue";
import Footer from "@/components/Footer.vue";
import FootBanner from "@/components/FootBanner.vue";
export default {
  metaInfo() {
    return {
      title: "Permission comparison",
      meta: [
        { property: "og:title", content: "Permission comparison" },
        { property: "og:description", content: "Permission comparison" },
        {
          property: "og:url",
          content: "https://totok.ai/permission-comparison",
        },
        { property: "og:type", content: "website" },
        {
          property: "og:image",
          content: "https://static.totok.ai/pic/preview/free_unblocked_call.png",
        },
        { property: "og:site_name", content: "ToTok" },
      ],
    };
  },
  components: {
    NewsBar,
    Footer,
    FootBanner,
  },
  data() {
    return {
      showinfo: false,
      isActive: "Jan05",
      leftMenus: [
        {
          title: "Jan 05",
          anchorId: "Jan05",
        },
        {
          title: "Dec 29",
          anchorId: "Dec29",
        },
        {
          title: "Dec 27",
          anchorId: "Dec27",
        },
        {
          title: "Dec 24",
          anchorId: "Dec24",
        },
        {
          title: "Dec 23",
          anchorId: "Dec23",
        },
      ],
    };
  },
  computed: {
    info() {
      return [];
    },
    isPc() {
      return document.body.offsetWidth > 450;
    },
    isIOS() {
      return navigator.userAgent.toLowerCase().indexOf("iphone") >= 0;
    },
  },
  methods: {
    gotoHandle(palice) {
      console.log("palice", palice);
      switch (palice) {
        case "Jan05":
          this.isActive = "Jan05";
          this.$router.push({ name: "newsJan05" });
          // this.mainPannel.scrollTo(0, 2000)
          break;
        case "Dec29":
          this.isActive = "Dec29";
          this.$router.push({ name: "newsDec29" });
          // this.mainPannel.scrollTo(0, 2000)
          break;
        case "Dec27":
          this.isActive = "Dec27";
          this.$router.push({ name: "newsDec27" });
          // this.mainPannel.scrollTo(0, 2000)
          break;
        case "Dec24":
          this.isActive = "Dec24";
          this.$router.push({ name: "newsDec24" });
          // this.mainPannel.scrollTo(0, 2000)
          break;
        case "Dec23":
          this.isActive = "Dec23";
          // this.$router.push({name:'newsDec22'})
          // this.mainPannel.scrollTo(0, 0)
          this.$router.push({ name: "newsDec22" });
          break;
      }
    },
  },
};
</script>
<style scoped lang="stylus">
@media only screen and (max-width: 700px) {
  .primaryInfo {
    // padding: 0.8rem;
    background: #fff;
    height: auto;

    .innerBox {
      padding-bottom: 50px;
    }

    .leftMenu {
      display: none;
    }

    div {
      margin-left: 20px;
      margin-right: 20px;
    }

    .info {
      margin-top:50px;
      h1 {
        font-family: -apple-system, 'Segeo UI', 'Helvetica Neue', sans-serif, Oxygen, Roboto;
        font-size: 28px;
        font-weight: 400;
        color: #4378f2;
        -webkit-font-smoothing: antialiased;
        padding-bottom: 20px;
        padding-top: 40px;
        margin: 0px;
        word-break: break-all;
        line-height: 40px;
      }

      h2 {
        font-family: -apple-system, 'Segeo UI', 'Helvetica Neue', sans-serif, Oxygen, Roboto;
        font-size: 24px;
        font-weight: 400;
        color: #4377f2;
        -webkit-font-smoothing: antialiased;
        padding-bottom: 18px;
        padding-top: 28px;
        margin: 0px;
      }

      h3 {
        font-family: -apple-system, 'Segeo UI', 'Helvetica Neue', sans-serif, Oxygen, Roboto;
        font-size: 16px;
        font-weight: 400;
        color: #808080;
        padding-bottom: 20px;
        margin: 0;
      }

      h6 {
        font-family: -apple-system, 'Segeo UI', 'Helvetica Neue', sans-serif, Oxygen, Roboto;
        font-style: italic;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 12px;
        color: #555555;
        text-rendering: optimizeLegibility;
        line-height: 26px;
      }

      p {
        font-family: -apple-system, 'Segeo UI', 'Helvetica Neue', sans-serif, Oxygen, Roboto;
        font-size: 16px;
        font-weight: normal;
        margin-bottom: 12px;
        color: #555555;
        text-rendering: optimizeLegibility;
        line-height: 26px;
      }

      ul {
        list-style: disc;
        font-family: -apple-system, 'Segeo UI', 'Helvetica Neue', sans-serif, Oxygen, Roboto;
        font-size: 16px;
        font-weight: normal;
        margin-top: 0;
        margin-bottom: 10px;
        margin-left: 24px;
        color: #555555;
        text-rendering: optimizeLegibility;
        line-height: 26px;
      }

      li {
        font-family: -apple-system, 'Segeo UI', 'Helvetica Neue', sans-serif, Oxygen, Roboto;
        font-size: 16px;
        font-weight: normal;
        margin-top: 0px;
        margin-bottom: 10px;
        color: #555555;
        text-rendering: optimizeLegibility;
        line-height: 26px;
        margin-left: 20px;
      }

      a {
        font-family: -apple-system, 'Segeo UI', 'Helvetica Neue', sans-serif, Oxygen, Roboto;
        font-size: 16px;
        font-weight: normal;
        margin-bottom: 12px;
        color: #4377f2;
        text-rendering: optimizeLegibility;
        line-height: 26px;
      }

      .img_container {
        width: 100%;
        margin: 30px 0px;
      }

      .img_container-item {
       width: 100%;
      }
      .img_container-item--last {
       margin-bottom:30px;
      }
      .img_container-item--first {
       margin-top:30px;
      }
      .img_desc{
        margin-bottom: 70px;
        display: inline-block;
        font-size: 10px;
        font-style: italic;
        line-height: 15px;
        font-family: SFProText-RegularItalic;
        color: #000;
      }


    }
  }

  .cp {
    height: 3.5rem;
    font-size: 13px;
    color: #808080;
    line-height: 3.5rem;
    text-align: center;
  }
}

@media only screen and (min-width: 701px) {
  .primaryInfo {
    padding-top: 86px;
    width: 100vw;
    background: #fff;

    .information {
      margin: 0 auto;
      width: 1024px;

      .innerBox {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        min-height: 83vh;
        overflow: auto;

        .leftMenu {
          position: absolute;
          left: 0px;
          top: 39px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          list-style: none;

          .menu-item {
            color: #979797;
            margin-top: 30px;
            cursor: pointer;
            text-decoration: none;
            font-size: 15px;
          }

          .menu-item:nth-child(1) {
            margin-top: 0px;
          }

          .menu-item--active {
            color: #000;
            border-bottom: 2px solid #4377f2;
          }
        }
      }
    }

    .info {
      width: 620px;
      margin: 20px 0;


      h1 {
        font-family: -apple-system, 'Segeo UI', 'Helvetica Neue', sans-serif, Oxygen, Roboto;
        font-size: 28px;
        font-weight: 400;
        color: #4378f2;
        -webkit-font-smoothing: antialiased;
        padding-bottom: 20px;
        padding-top: 40px;
        margin: 0px;
        word-break: break-all;
        line-height: 40px;
      }

      h2 {
        font-family: -apple-system, 'Segeo UI', 'Helvetica Neue', sans-serif, Oxygen, Roboto;
        font-size: 24px;
        font-weight: 400;
        color: #4377f2;
        -webkit-font-smoothing: antialiased;
        padding-bottom: 18px;
        padding-top: 28px;
        margin: 0px;
      }

      h3 {
        font-family: -apple-system, 'Segeo UI', 'Helvetica Neue', sans-serif, Oxygen, Roboto;
        font-size: 16px;
        font-weight: 400;
        color: #808080;
        padding-bottom: 20px;
        margin: 0;
      }

      h6 {
        font-family: -apple-system, 'Segeo UI', 'Helvetica Neue', sans-serif, Oxygen, Roboto;
        font-style: italic;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 12px;
        color: #555555;
        text-rendering: optimizeLegibility;
        line-height: 26px;
      }

      p {
        font-family: -apple-system, 'Segeo UI', 'Helvetica Neue', sans-serif, Oxygen, Roboto;
        font-size: 16px;
        font-weight: normal;
        margin-bottom: 12px;
        color: #555555;
        text-rendering: optimizeLegibility;
        line-height: 26px;
      }

      ul {
        list-style: disc;
        font-family: -apple-system, 'Segeo UI', 'Helvetica Neue', sans-serif, Oxygen, Roboto;
        font-size: 16px;
        font-weight: normal;
        margin-top: 0;
        margin-bottom: 10px;
        margin-left: 24px;
        color: #555555;
        text-rendering: optimizeLegibility;
        line-height: 26px;
      }

      li {
        font-family: -apple-system, 'Segeo UI', 'Helvetica Neue', sans-serif, Oxygen, Roboto;
        font-size: 16px;
        font-weight: normal;
        margin-top: 0px;
        margin-bottom: 10px;
        color: #555555;
        text-rendering: optimizeLegibility;
        line-height: 26px;
        margin-left: 20px;
      }

      a {
        font-family: -apple-system, 'Segeo UI', 'Helvetica Neue', sans-serif, Oxygen, Roboto;
        font-size: 16px;
        font-weight: normal;
        margin-bottom: 12px;
        color: #4377f2;
        text-rendering: optimizeLegibility;
        line-height: 26px;
      }

      .img_container {
        width: 100%;
        margin: 30px 0px;
      }

      .img_container-item {
       width: 100%;
      }
      .img_container-item--last {
       margin-bottom:30px;
      }
      .img_container-item--first {
       margin-top:30px;
      }
      .img_desc{
        margin-bottom: 70px;
        display: inline-block;
        font-size: 10px;
        font-style: italic;
        line-height: 15px;
        font-family: SFProText-RegularItalic;
        color: #000;
      }
    }
  }

  .cp {
    height: 70px;
    font-size: 13px;
    color: #808080;
    line-height: 70px;
    text-align: center;
  }
}
</style>
